<template>
	<a
		rel="noopener noreferrer"
		href="https://ibe.sabeeapp.com/v3/p/Ogygia-Suites?p=d676312cbc6a2853&lang=En"
		target="_blank"
	>
		<slot />
	</a>
</template>

<script setup>
defineProps({
	language: { type: String, default: '' },
	arrival: { type: String, default: '' },
	departure: { type: String, default: '' },
	pax: { type: String, default: '' },
	packageid: { type: String, default: '' },
	roomid: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	svg {
		margin: 0 5px 0 0;
	}

	&.fixedmobile {
		display: none;
		width: 100%;
		position: fixed;
		bottom: 0;
		margin: 0;
		padding: 20px 0;
		z-index: 100;

		svg {
			margin-right: 5px;
		}
	}

	&:hover {
		text-decoration: none;
	}
}

@media (max-width: 920px) {
	a.fixedmobile {
		display: block;
	}
}
</style>
